import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Faucet from "./pages/Faucet";
import Quest from "./pages/Quest";
import Swap from "./pages/Swap";
import Home from "./pages/Home";
import Footer from "./components/Footer";

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/faucet" element={<Faucet />} />
            <Route path="/quest" element={<Quest />} />
            <Route path="/swap" element={<Swap />} />
            <Route path="*" element={
              <div className="flex items-center justify-center h-screen">
                <div className="text-center p-8 bg-gray-800/50 rounded-2xl border border-gray-700/50">
                  <h1 className="text-4xl font-bold text-[#00df9a] mb-4">404</h1>
                  <p className="text-xl text-gray-300">Page Not Found</p>
                </div>
              </div>
            } />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;